<template>
  <div class="company-address-container">
    <div class="company-address-content">
      <div class="address-block">
        <div class="address-block-left">
          <div
            v-for="item in locations"
            :key="item.id"
            class="location-card"
            :class="{ active: activeId === item.id }"
            @click="switchLocation(item.id)"
          >
            <div class="card-label">{{ item.label }}</div>
            <div class="card-divider"></div>
            <div class="card-name">{{ item.name }}</div>
            <div class="card-line">{{ item.address }}</div>
            <div v-if="item.phone" style="margin-top: 15px" class="card-line">
              电话：{{ item.phone }}
            </div>
            <div v-if="item.email" class="card-line">
              邮箱：{{ item.email }}
            </div>
          </div>
        </div>

        <div class="address-block-right">
          <el-amap
            :key="mapKey"
            class="amap"
            :center="activeLocation.center"
            :zoom="activeLocation.zoom"
            :plugin="plugins"
          >
            <el-amap-marker
              :position="activeLocation.center"
              :icon="markerIcon"
              :label="{
                content: activeLocation.mapLabel,
                direction: 'top',
                offset: activeLocation.labelOffset,
              }"
            >
            </el-amap-marker>
          </el-amap>
        </div>
      </div>

      <div class="form-content">
        <div class="form-title page-block-title">在线留言</div>
        <div class="form">
          <el-form ref="form" :rules="rules" :model="form" label-width="100px">
            <div class="row">
              <el-form-item label="姓名:" prop="name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="电话:" prop="phone">
                <el-input v-model="form.phone"></el-input>
              </el-form-item>
            </div>

            <el-form-item label="问题建议:" prop="feedback">
              <el-input
                type="textarea"
                :rows="5"
                v-model="form.feedback"
              ></el-input>
            </el-form-item>
          </el-form>

          <div class="button-submit" @click="submit">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toFeedBack } from "../../util/api.js";

export default {
  data() {
    return {
      activeId: "hq",
      mapVersion: 0,
      centersResolved: false,
      markerIcon:
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/blue_location.png",
      plugins: ["AMap.Geocoder", "AMap.PlaceSearch", "AMap.Marker"],
      locations: [
        {
          id: "hq",
          label: "企业总部",
          name: "焱图慧云（苏州）信息科技有限公司",
          address: "江苏省苏州市吴中区木渎镇金枫路218号3号楼赢客空间13楼1301",
          searchKeywords: ["赢客三环", "金枫路218号", "赢客空间"],
          city: "苏州",
          phone: "0512-67367378",
          email: "service@yantucloud.com",
          mapLabel: "焱图慧云（苏州）信息科技有限公司",
          center: [120.539563, 31.275748],
          zoom: 16,
          labelOffset: [-160, -55],
        },
        {
          id: "factory",
          label: "企业工厂",
          name: "焱图智能机器人（盐城）有限公司",
          address: "江苏盐城市滨海县滨海经济开发区工业园南区电子智慧园16栋",
          searchKeywords: ["滨海电子智慧园", "电子智慧园", "电子智慧园16栋"],
          preferNameIncludes: ["电子智慧园", "智慧园"],
          excludeNameIncludes: ["电子信息产业园", "信息产业园"],
          city: "盐城",
          phone: "",
          email: "",
          mapLabel: "焱图智能机器人（盐城）有限公司",
          center: [119.820833, 33.960278],
          zoom: 16,
          labelOffset: [-150, -55],
        },
      ],
      form: {},
      rules: {
        name: [{ required: true, message: "姓名必填", trigger: "blur" }],
        phone: [{ required: true, message: "电话必填", trigger: "blur" }],
        feedback: [{ required: true, message: "建议必填", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.resolveLocationCenters();
  },
  computed: {
    activeLocation() {
      return (
        this.locations.find((item) => item.id === this.activeId) ||
        this.locations[0]
      );
    },
    mapKey() {
      const center = this.activeLocation.center || [];
      return `${this.activeId}-${center[0]}-${center[1]}-${this.mapVersion}`;
    },
  },
  methods: {
    switchLocation(id) {
      this.activeId = id;
    },

    setLocationCenter(index, lng, lat) {
      this.$set(this.locations[index], "center", [lng, lat]);
      this.mapVersion += 1;
    },

    resolveLocationCenters() {
      if (this.centersResolved) return;

      const run = () => {
        if (!window.AMap) {
          setTimeout(run, 300);
          return;
        }
        this.centersResolved = true;
        window.AMap.plugin(["AMap.PlaceSearch", "AMap.Geocoder"], () => {
          this.locations.forEach((loc, index) => {
            this.resolveOneLocation(loc, index);
          });
        });
      };

      run();
    },

    resolveOneLocation(loc, index) {
      const keywords = loc.searchKeywords || [loc.address];
      const placeSearch = new window.AMap.PlaceSearch({
        city: loc.city,
        citylimit: true,
        pageSize: 10,
      });

      const pickPoi = (pois) => {
        if (!pois || !pois.length) return null;
        const prefer = loc.preferNameIncludes || [];
        const exclude = loc.excludeNameIncludes || [];

        const filtered = pois.filter((poi) => {
          const name = `${poi.name || ""}${poi.address || ""}`;
          if (exclude.some((word) => name.indexOf(word) > -1)) return false;
          return true;
        });

        if (prefer.length) {
          const preferred = filtered.find((poi) => {
            const name = `${poi.name || ""}${poi.address || ""}`;
            return prefer.some((word) => name.indexOf(word) > -1);
          });
          if (preferred) return preferred;
        }

        return filtered[0] || null;
      };

      const tryKeyword = (keywordIndex) => {
        if (keywordIndex >= keywords.length) {
          // POI 搜不到时，用完整地址做地理编码（同样避开错误园区名）
          const geocoder = new window.AMap.Geocoder({ city: loc.city });
          geocoder.getLocation(loc.address, (geoStatus, geoResult) => {
            if (
              geoStatus === "complete" &&
              geoResult.geocodes &&
              geoResult.geocodes.length
            ) {
              const exclude = loc.excludeNameIncludes || [];
              const prefer = loc.preferNameIncludes || [];
              let geocode = geoResult.geocodes.find((item) => {
                const text = `${item.formattedAddress || ""}${
                  item.level || ""
                }`;
                return (
                  !exclude.some((word) => text.indexOf(word) > -1) &&
                  (!prefer.length ||
                    prefer.some((word) => text.indexOf(word) > -1))
                );
              });
              if (!geocode) {
                geocode = geoResult.geocodes.find((item) => {
                  const text = `${item.formattedAddress || ""}`;
                  return !exclude.some((word) => text.indexOf(word) > -1);
                });
              }
              geocode = geocode || geoResult.geocodes[0];
              const { lng, lat } = geocode.location;
              this.setLocationCenter(index, lng, lat);
            }
          });
          return;
        }

        placeSearch.search(keywords[keywordIndex], (status, result) => {
          if (
            status === "complete" &&
            result.poiList &&
            result.poiList.pois &&
            result.poiList.pois.length
          ) {
            const poi = pickPoi(result.poiList.pois);
            if (poi) {
              this.setLocationCenter(index, poi.location.lng, poi.location.lat);
              return;
            }
          }
          tryKeyword(keywordIndex + 1);
        });
      };

      tryKeyword(0);
    },

    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          toFeedBack(this.form)
            .then((res) => {
              if (res.data.status == "success") {
                this.form = {};
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
  },
};
</script>

<style>
.amap-marker-label {
  border: none;
  height: auto;
  min-height: 44px;
  line-height: 44px;
  padding: 0 16px;
  width: auto;
  max-width: none;
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}

.amap-marker-label::before {
  content: "";
  width: 0;
  height: 0;
  border: 12px solid;
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
  border-color: #fff transparent transparent;
}

.amap-marker-label::after {
  display: none;
}

@media only screen and (max-width: 768px) {
  .amap-marker-label {
    font-size: 13px;
    min-height: 36px;
    line-height: 36px;
    padding: 0 10px;
    max-width: none;
    white-space: nowrap;
  }
}
</style>

<style lang="stylus" scoped>
.company-address-container
  .company-address-content
    max-width var(--main-width)
    width 84%
    margin 3rem auto 5rem

    .address-block
      display flex
      align-items stretch
      justify-content space-between
      gap 2.5rem

    .address-block-left
      flex 0 0 28rem
      max-width 42%
      display flex
      flex-direction column
      justify-content center
      gap 2.5rem

    .location-card
      position relative
      padding 1.5rem 1.75rem
      cursor pointer
      transition background 0.25s, color 0.25s, box-shadow 0.25s
      color #333
      background transparent

      .card-label
        font-size 0.875rem
        color #999
        line-height 1.4

      .card-divider
        width 100%
        height 1px
        background #E5E5E5
        margin 0.75rem 0 1rem

      .card-name
        font-size 1.25rem
        font-weight 600
        line-height 1.5
        margin-bottom 0.75rem
        color #333

      .card-line
        font-size 0.9375rem
        line-height 1.7
        color #666

      &.active
        background #2372E9
        color #fff
        box-shadow 0 10px 28px rgba(35, 114, 233, 0.22)

        .card-label
          color rgba(255, 255, 255, 0.9)

        .card-divider
          background rgba(255, 255, 255, 0.45)

        .card-name
        .card-line
          color #fff

        &::after
          content ""
          position absolute
          top 50%
          right -14px
          transform translateY(-50%)
          width 0
          height 0
          border-style solid
          border-width 12px 0 12px 14px
          border-color transparent transparent transparent #2372E9

    .address-block-right
      flex 1
      min-width 0

      .amap
        width 100%
        height 32rem
        min-height 480px

    .form-content
      margin 5.5rem 0 9.3rem

      .form-title
        position relative
        text-align center
        margin-bottom 4.9rem

      /deep/ .el-form-item__label
        font-size 16px

      .form
        max-width 70rem
        margin 0 auto

        .row
          display flex
          width 100%
          gap 2rem

          /deep/ .el-form-item
            flex 1

        .button-submit
          width 166px
          height 50px
          background #2372E9
          text-align center
          cursor pointer
          color #fff
          line-height 50px
          margin 2rem auto 0
          border-radius 3px

          &:hover
            background #1b5fc7

@media only screen and (max-width: 1200px) and (min-width: 769px)
  .company-address-container
    .company-address-content
      .address-block
        flex-wrap wrap

      .address-block-left
        flex 1 1 100%
        max-width 100%
        flex-direction row
        align-items stretch

      .location-card
        flex 1

        &.active::after
          display none

      .address-block-right
        width 100%

        .amap
          height 28rem

@media only screen and (max-width: 768px)
  .company-address-container
    .company-address-content
      width calc(100% - 30px)
      margin 1.25rem auto 2rem

      .address-block
        flex-direction column
        gap 1.25rem

      .address-block-left
        flex 1 1 auto
        max-width 100%
        gap 1rem

      .location-card
        padding 1.125rem 1rem

        &.active::after
          display none

        .card-name
          font-size 1.0625rem

        .card-line
          font-size 0.8125rem

      .address-block-right
        .amap
          height 16rem
          min-height 260px

      .form-content
        margin 2.5rem 0 2rem

        .form-title
          font-size 1.375rem !important
          margin-bottom 2rem !important

        .form
          .row
            flex-direction column
            gap 0

          .button-submit
            width 120px
            height 40px
            line-height 40px
            font-size 14px
</style>
